import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Label from "../../components/label";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function ResidentialPage() {
  return (
    <div className="p-0">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = usePageProvider();

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Form>
          <Accordion defaultActiveKey="0" className="my-4">
            {/* SEO SECTION */}
            <Accordion.Item eventKey="0" className="w-full">
              <Accordion.Header>SEO META</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div className="flex flex-col">
                    <Label label="Meta Title" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_title" placeholder="Meta Title" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Keywords" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_keyword" placeholder="Meta Keywords" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Slug Url" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_slug_url" placeholder="Meta Slug Url" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col col-span-3">
                    <Label label="Meta Description" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_desc" placeholder="Meta Description" rootClassName="w-full" as={"textarea"} />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* BANNER SECTION */}
            <Accordion.Item eventKey="1" className="w-full">
              <Accordion.Header>Banner Section</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 pb-6 border-b border-gray-100">
                  <div>
                    <Label label="Heading (White)" className="mb-1 " />
                    <FormikInput name="banner.heading.white" placeholder="Heading (White)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1 " />
                    <FormikInput name="banner.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1 " />
                    <FormikInput name="banner.subHeading" placeholder="Sub Heading" />
                  </div>
                  <div>
                    <Label label="Cta Title" className="mb-1 " />
                    <FormikInput name="banner.cta_title" placeholder="Cta Title" />
                  </div>
                  <div>
                    <Label label="Cta Download" className="mb-1 " />
                    <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                      title="Asset"
                      imageUrl={values.banner?.cta_download}
                      onChange={(res) => setFieldValue("banner.cta_download", res?.data?.file_url)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div>
                    <Label label="Banner Context Paragraphs" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="banner.paragraphs">
                      {(arrayHelpers) => (
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                            <thead className="bg-gray-50 border-b">
                              <tr>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Paragraph Content</th>
                                <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y">
                              {values.banner?.paragraphs?.map((p, index) => (
                                <tr key={index} className="hover:bg-gray-50/50">
                                  <td className="p-2 border-r">
                                    <FormikTextarea name={`banner.paragraphs.${index}`} rootClassName="w-full" className="text-sm !h-20" />
                                  </td>
                                  <td className="p-2 text-center align-middle">
                                    <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600">
                                      <FontAwesomeIcon icon={faTrash} size="sm" />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="mt-3">
                            <Button type="button" variant="outline" className="!py-1 !px-4 !text-[11px]" onClick={() => arrayHelpers.push("")}>
                              + Add Paragraph
                            </Button>
                          </div>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <div>
                    <Label label="Banner Background Image" className="mb-2 text-black font-semibold" />
                    <ImageUploader
                      imageUrl={values.banner?.image}
                      onChange={(res) => setFieldValue("banner.image", res?.data?.file_url)}
                      imgStyle={{ width: "100%", height: "200px" }}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* DETAIL SECTION */}
            <Accordion.Item eventKey="2" className="w-full">
              <Accordion.Header>Detailed Living Concepts</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
                  <div>
                    <Label label="Title" className="mb-1 " />
                    <FormikInput name="detailSection.title" placeholder="Title" />
                  </div>
                  <div>
                    <Label label="Description" className="mb-1 " />
                    <FormikInput name="detailSection.desc" placeholder="Description" />
                  </div>
                  <div>
                    <Label label="Heading (Black)" className="mb-1 " />
                    <FormikInput name="detailSection.heading.black" placeholder="Heading (Black)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1 " />
                    <FormikInput name="detailSection.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading / Phrase" className="mb-1 " />
                    <FormikInput name="detailSection.sub_heading" placeholder="Sub Heading" />
                  </div>
                </div>

                <div className="mb-8">
                  <Label label="Living Standards & Details" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs pt-4 border-t" />
                  <FieldArray name="detailSection.content">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-32">Type</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Feature Description</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.detailSection?.content?.map((item, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r align-top">
                                  <FormikInput
                                    name={`detailSection.content.${index}.type`}
                                    placeholder="para/title"
                                    className="text-xs font-black uppercase text-gray-400"
                                  />
                                </td>
                                <td className="p-2 border-r align-top">
                                  <FormikTextarea
                                    name={`detailSection.content.${index}.text`}
                                    placeholder="Feature text..."
                                    className="text-sm !h-16"
                                  />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                    <FontAwesomeIcon icon={faTrash} size="sm" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-4">
                          <Button type="button" variant="outline" className="!py-2 !px-4 !text-[12px]" onClick={() => arrayHelpers.push({ type: "para", text: "" })}>
                            + Add Living Detail
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 pt-6 border-t border-gray-100">
                  <div>
                    <Label label="Conceptual Living image" className="mb-2 " />
                    <ImageUploader
                      imageUrl={values.detailSection?.image?.url}
                      onChange={(res) => setFieldValue("detailSection.image.url", res?.data?.file_url)}
                      imgStyle={{ width: "100%", height: "250px" }}
                    />
                  </div>
                  <div className="flex flex-col justify-center">
                    <Label label="Image Alt Tag (SEO)" className="mb-1" />
                    <FormikInput name="detailSection.image.alt" placeholder="Image Alt Text" />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* DISTANCE SECTION */}
            <Accordion.Item eventKey="3" className="w-full">
              <Accordion.Header>Connectivity & Landmarks</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <Label label="Proximity Heading" className="mb-1 " />
                      <FormikInput name="distanceSection.title" placeholder="Landmark Title" />
                    </div>
                    <div>
                      <Label label="Proximity Description" className="mb-1 " />
                      <FormikTextarea name="distanceSection.desc" placeholder="Landmark Description" className="!h-20" />
                    </div>
                  </div>

                  <Label label="Landmark Proximity List" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs pt-4 border-t" />
                  <FieldArray name="distanceSection.cards">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Destination</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Distance Ratio</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.distanceSection?.cards?.map((card, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r align-top">
                                  <FormikInput name={`distanceSection.cards.${index}.city`} placeholder="Place Name" className="text-sm font-semibold" />
                                </td>
                                <td className="p-2 border-r align-top">
                                  <FormikInput name={`distanceSection.cards.${index}.distance`} placeholder="e.g. 15 Mins" className="text-sm" />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-4">
                          <Button type="button" variant="outline" className="!py-2 !px-4 !text-[12px]" onClick={() => arrayHelpers.push({ city: "", distance: "" })}>
                            + Add Landmark Connection
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>

                  <div className="pt-4 border-t border-gray-100">
                    <Label label="Summary Paragraph" className="mb-1 " />
                    <FormikTextarea name="distanceSection.bottom_para" placeholder="Bottom Connectivity Paragraph" />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* AMENITIES */}
            <Accordion.Item eventKey="4" className="w-full">
              <Accordion.Header>Amenities</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 pb-6 border-b border-gray-100">
                  <div>
                    <Label label="Heading" className="mb-1 " />
                    <FormikInput name="amenities.title" placeholder="Heading" />
                  </div>
                  <div>
                    <Label label="Highlight" className="mb-1 " />
                    <FormikInput name="amenities.highlight" placeholder="Highlight" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1 " />
                    <FormikInput name="amenities.subtitle" placeholder="Sub Heading" />
                  </div>
                  <div>
                    <Label label="Description" className="mb-1 " />
                    <FormikInput name="amenities.desc" placeholder="Description" />
                  </div>
                  <div>
                    <Label label="Image" className="mb-1 " />
                    <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                      title="Asset"
                      imageUrl={values.amenities?.image}
                      onChange={(res) => setFieldValue("amenities.image", res?.data?.file_url)}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* USE CASES */}
            <Accordion.Item eventKey="5" className="w-full">
              <Accordion.Header>Versatile Use Cases (Residential)</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pb-4">
                    <div>
                      <Label label="Case Primary Title" className="mb-1 " />
                      <FormikInput name="useCases.heading.title" placeholder="Title" />
                    </div>
                    <div>
                      <Label label="Case Highlight" className="mb-1 " />
                      <FormikInput name="useCases.heading.highlight" placeholder="Elite Lifestyle" />
                    </div>
                    <div>
                      <Label label="Context Caption" className="mb-1 " />
                      <FormikInput name="useCases.heading.subtitle" placeholder="Subtitle" />
                    </div>
                  </div>

                  <Label label="Configured Use Case Grid" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs pt-4 border-t" />
                  <FieldArray name="useCases.items">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-1/4">Feature Title</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Brief Detail</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-32">Icon</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-12"></th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.useCases?.items?.map((item, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r align-top">
                                  <FormikInput name={`useCases.items.${index}.title`} placeholder="Title" className="text-sm font-semibold" />
                                </td>
                                <td className="p-2 border-r align-top">
                                  <FormikTextarea name={`useCases.items.${index}.desc`} placeholder="Description" className="text-sm !h-16" />
                                </td>
                                <td className="p-2 border-r align-middle">
                                  <ImageUploader
                                    imgStyle={{ width: "45px", height: "45px" }}
                                    imageUrl={item.icon}
                                    onChange={(res) => setFieldValue(`useCases.items.${index}.icon`, res?.data?.file_url)}
                                  />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-700">
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-4">
                          <Button type="button" variant="outline" className="!py-2 !px-6 !text-[12px]" onClick={() => arrayHelpers.push({ title: "", desc: "", icon: "" })}>
                            + Add Residential Use Case
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* OFFERING SECTION */}
            <Accordion.Item eventKey="6" className="w-full">
              <Accordion.Header>Elite Offerings</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
                  <div>
                    <Label label="Offer Main Title" className="mb-1 " />
                    <FormikInput name="offering.title" placeholder="Elite Offerings" />
                  </div>
                  <div>
                    <Label label="Offer Accent Highlight" className="mb-1 " />
                    <FormikInput name="offering.highlight" placeholder="Curated Spaces" />
                  </div>
                  <div>
                    <Label label="Offer Subtitle" className="mb-1 " />
                    <FormikInput name="offering.subtitle" placeholder="Subtitle" />
                  </div>
                  <div className="sm:col-span-3">
                    <Label label="Explanatory Offering Prose" className="mb-1 " />
                    <FormikTextarea name="offering.desc" placeholder="Describe the offering..." />
                  </div>
                </div>
                <div className="pt-6 border-t">
                  <Label label="Key Offering Visual" className="mb-2 " />
                  <ImageUploader
                    imageUrl={values.offering?.image}
                    onChange={(res) => setFieldValue("offering.image", res?.data?.file_url)}
                    imgStyle={{ width: "100%", height: "250px" }}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* INFRASTRUCTURE & SAFETY */}
            <Accordion.Item eventKey="7" className="w-full">
              <Accordion.Header>Amenities & Security Protocols</Accordion.Header>
              <Accordion.Body>
                <div className="space-y-12">
                  {/* Infrastructure Layer */}
                  <div className="border border-gray-100 rounded-3xl p-6 bg-gray-50/20 shadow-sm relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 bg-indigo-50 rounded-bl-3xl text-indigo-700 font-black text-[10px] uppercase tracking-widest">Amenities Layer</div>
                    <h5 className="font-black text-xl mb-6 text-[#1e1e5c] border-b pb-2">
                      Lifestyle Amenities
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                      <div className="space-y-4">
                        <div><Label label="Section Title" className="mb-1" /><FormikInput name="infrastructure.infrastructure.title" /></div>
                        <div><Label label="Section Highlight" className="mb-1" /><FormikInput name="infrastructure.infrastructure.highlight" /></div>
                        <div><Label label="Brief Caption" className="mb-1" /><FormikInput name="infrastructure.infrastructure.subtitle" /></div>
                        <div><Label label="Context Note" className="mb-1" /><FormikInput name="infrastructure.infrastructure.note" /></div>
                      </div>
                      <div className="flex flex-col justify-end">
                        <Label label="Amenities Visualizer" className="mb-2" />
                        <ImageUploader
                          imageUrl={values.infrastructure?.infrastructure?.image}
                          onChange={(res) => setFieldValue("infrastructure.infrastructure.image", res?.data?.file_url)}
                          imgStyle={{ width: "100%", height: "180px" }}
                        />
                      </div>
                    </div>

                    <Label label="Amenities Blueprint" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="infrastructure.infrastructure.points">
                      {(arrayHelpers) => (
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                            <thead className="bg-gray-50 border-b">
                              <tr>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Amenity Tag</th>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-40">Detail Icon</th>
                                <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y">
                              {values.infrastructure?.infrastructure?.points?.map((p, index) => (
                                <tr key={index} className="hover:bg-gray-50/50">
                                  <td className="p-2 border-r align-middle"><FormikInput name={`infrastructure.infrastructure.points.${index}.text`} className="text-sm" /></td>
                                  <td className="p-2 border-r align-middle">
                                    <ImageUploader
                                      imgStyle={{ width: "40px", height: "40px" }}
                                      imageUrl={p.icon}
                                      onChange={(res) => setFieldValue(`infrastructure.infrastructure.points.${index}.icon`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="p-2 text-center align-middle">
                                    <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-500"><FontAwesomeIcon icon={faTrash} /></button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="mt-4"><Button type="button" variant="outline" className="!py-2 !px-4 !text-[11px]" onClick={() => arrayHelpers.push({ text: "", icon: "" })}>+ Add Amenity Item</Button></div>
                        </div>
                      )}
                    </FieldArray>
                  </div>

                  {/* Safety Layer */}
                  <div className="border border-gray-100 rounded-3xl p-6 bg-gray-50/20 shadow-sm relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 bg-orange-50 rounded-bl-3xl text-orange-700 font-black text-[10px] uppercase tracking-widest">Security Layer</div>
                    <h5 className="font-black text-xl mb-6 text-[#1e1e5c] border-b pb-2">
                      Smart Security & Safety Protocols
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                      <div className="space-y-4">
                        <div><Label label="Security Title" className="mb-1" /><FormikInput name="infrastructure.safety.title" /></div>
                        <div><Label label="Protocols Highlight" className="mb-1" /><FormikInput name="infrastructure.safety.highlight" /></div>
                        <div><Label label="Caption" className="mb-1" /><FormikInput name="infrastructure.safety.subtitle" /></div>
                      </div>
                      <div className="flex flex-col justify-end">
                        <Label label="Security Overview Image" className="mb-2" />
                        <ImageUploader
                          imageUrl={values.infrastructure?.safety?.image}
                          onChange={(res) => setFieldValue("infrastructure.safety.image", res?.data?.file_url)}
                          imgStyle={{ width: "100%", height: "180px" }}
                        />
                      </div>
                    </div>

                    <Label label="Active Safety Measures" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="infrastructure.safety.points">
                      {(arrayHelpers) => (
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                            <thead className="bg-gray-50 border-b">
                              <tr>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Protocol Specification</th>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-40">System Icon</th>
                                <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y">
                              {values.infrastructure?.safety?.points?.map((p, index) => (
                                <tr key={index} className="hover:bg-gray-50/50">
                                  <td className="p-2 border-r align-middle"><FormikInput name={`infrastructure.safety.points.${index}.text`} className="text-sm" /></td>
                                  <td className="p-2 border-r align-middle">
                                    <ImageUploader
                                      imgStyle={{ width: "40px", height: "40px" }}
                                      imageUrl={p.icon}
                                      onChange={(res) => setFieldValue(`infrastructure.safety.points.${index}.icon`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="p-2 text-center align-middle">
                                    <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-500"><FontAwesomeIcon icon={faTrash} /></button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="mt-4"><Button type="button" variant="outline" className="!py-2 !px-4 !text-[11px]" onClick={() => arrayHelpers.push({ text: "", icon: "" })}>+ Add Safety Protocol</Button></div>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8" className="w-full">
              <Accordion.Header>{"Footer Banner Image"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 mb-6">
                  <Label label="Footer Banner Image" className="mb-1" />
                  <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                    title="Footer Banner Image"
                    imageUrl={values.footer_bgimg}
                    onChange={(res) => setFieldValue("footer_bgimg", res?.data?.file_url)}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* FIXED BOTTOM SAVE BAR */}
          <div className="save-button-bar !bg-white/95 !backdrop-blur-md">
            <Button
              type="submit"
              label="SAVE CHANGES"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
